import React from "react";
import "./bfsiblog.scss";
import { Container, Grid2, useMediaQuery } from "@mui/material";
import DateInfo from "../../dateinfo/DateInfo";
import { Share, ShareOutlined } from "@mui/icons-material";
import Card1 from "./Card1";
import HyperPersonalization from "./HyperPersonalization";
import AutomationSection from "./AutomationSection";
import CustomerTransparency from "./CustomerTransparency";
import SalesforceBackbone from "./SalesforceBackbone";
import ConnectedSection from "./ConnectedSection";
import UtilitarianSection from "./UtilitarianSection";
import CtaSection from "./CtaSection";

const Bfsiblog = () => {
  // const isMobile = useMediaQuery("(max-width:599px)");
  return (
    <div className="bfsimainpage">
      <Grid2 className="bfblogimg">
        <img src="/images/top5.webp" alt="" />
        <div className="bfsicontblogs">
        <div className="headingbox">
            <h1>
            The Top 5 Trends Shaping BFSI in 2026 — A{" "}
            <span>Salesforce</span> Perspective
          </h1>
        </div>
        </div>
      </Grid2>

      <Container>
        <Grid2 className="shareblock">
          <div>
            <DateInfo
              date="April 2026"
              reading="7 min reading"
              team="Kiran Kumar Naik"
            />
          </div>
          <div>
            <ShareOutlined />
          </div>
        </Grid2>
        <hr className="hr" />
        <br />
        <p className="parentpara">
          The Banking, Financial Services, and Insurance (BFSI) industry is
          undergoing rapid digital transformation in 2026. Driven by evolving
          customer expectations, regulatory demands, and emerging technologies,
          organizations must rethink how they deliver value.  Platforms like
          Salesforce Financial Services Cloud are enabling BFSI institutions to
          unify customer data, automate operations, and deliver personalized,
          intelligent experiences at scale. 
        </p>
      </Container>
      <Card1 />
      <HyperPersonalization/>
      <AutomationSection/>
      <CustomerTransparency/>
      <ConnectedSection/>
      <SalesforceBackbone/>
      <UtilitarianSection/>
      <CtaSection/>
    </div>
  );
};

export default Bfsiblog;
